function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.83129 2.4375C3.05098 2.4375 2.41797 3.05124 2.41797 3.80735V20.1913C2.41797 20.9475 3.05105 21.5607 3.83129 21.5607H20.1278C20.9085 21.5607 21.5412 20.9474 21.5412 20.1911V3.80735C21.5412 3.05124 20.9085 2.4375 20.1278 2.4375H3.83129ZM8.2295 9.82983V18.4391H5.36789V9.82983H8.2295ZM8.41812 7.16732C8.41812 7.9935 7.79699 8.65459 6.79929 8.65459L6.79907 8.65451H6.78054C5.82012 8.65451 5.19922 7.99342 5.19922 7.16725C5.19922 6.32233 5.83887 5.67969 6.81827 5.67969C7.79699 5.67969 8.39944 6.32233 8.41812 7.16732ZM12.6748 18.4391H9.81344L9.81336 18.4394C9.81336 18.4394 9.85094 10.6378 9.81359 9.83013H12.675V11.0487C13.0554 10.4622 13.7362 9.62799 15.2541 9.62799C17.1367 9.62799 18.5483 10.8585 18.5483 13.5028V18.4391H15.6869V13.8339C15.6869 12.6764 15.2726 11.887 14.2374 11.887C13.4467 11.887 12.9759 12.4194 12.7691 12.9337C12.6935 13.1172 12.6748 13.3748 12.6748 13.6318V18.4391Z",
  fill: "#495A95"
});

var SvgSocialLinkedin = function SvgSocialLinkedin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSocialLinkedin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/social_linkedin.412fb5df.svg";
export { ForwardRef as ReactComponent };